namespace $.$$ {
	export class $bog_bzrl_app_hero extends $.$bog_bzrl_app_hero {
		Icon() {
			return this.icon_uri() ? super.Icon() : null!
		}

		Media() {
			return this.media_uri() ? super.Media() : null!
		}
	}
	export class $bog_bzrl_app_hero_promo extends $.$bog_bzrl_app_hero_promo {}
	export class $bog_bzrl_app_hero_privacy extends $.$bog_bzrl_app_hero_privacy {}
	export class $bog_bzrl_app_hero_team extends $.$bog_bzrl_app_hero_team {}
}
